import React, { memo } from 'react';
import cx from 'classnames';
import { useTranslation } from 'next-i18next';

import Icon from 'components/Icon';
import { TOpportunity } from 'lib/models/opportunity';

import styles from './OpportunityAiSummary.module.scss';

type OpportunityAiSummaryProps = {
  className?: string;
  ai_summary: TOpportunity['ai_summary'];
};

export const OpportunityAiSummary: React.FC<OpportunityAiSummaryProps> = memo(({ className = '', ai_summary }: OpportunityAiSummaryProps) => {
  const [tc] = useTranslation('common');

  if (!ai_summary?.length) return null;

  return (
    <div className={cx(styles.container, className)}>
      <div className={styles['list-heading']}>
        <Icon iconName="icon_magic-wand" size="xsmall" />
        <p>{tc('ai-generated-summary')}</p>
      </div>
      <ul>
        {ai_summary.map((summary, index) => (
          <li key={index}>{summary}</li>
        ))}
      </ul>
    </div>
  );
});

OpportunityAiSummary.displayName = 'OpportunityAiSummary';
